module.exports = __webpack_public_path__ + "img/plebianj_thumb.ec0ce905.jpg";